module.exports = "<nav class=\"leftsettingbox\">\r\n        <ul class=\"list-unstyled settinglist\">    \r\n          \r\n            <li><a [routerLink]=\"['complainList']\"  routerLinkActive=\"selected\"><strong> Complain List</strong></a></li>\r\n           \r\n        \r\n        </ul>     \r\n      </nav>  \r\n      <router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/crm/complain/complain.component.html
// module id = ./src/app/crm/complain/complain.component.html
// module chunks = main